module.exports = __webpack_public_path__ + "static/media/741b3275-420d-49a4-b2a1-11d2c4562446.d43df8ea.JPG";